"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";
const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
const nameGroups = [{
  letter: "A",
  names: "Abigail, Ada, Adeline, Alice, Amelia, Aria, Aurora, Ava, Avery, Aaliyah, Addison, Aubrey"
}, {
  letter: "B",
  names: "Bailey, Barbara, Beatrice, Bella, Bernadette, Bethany, Bianca, Blair, Brooklyn, Brielle, Brianna"
}, {
  letter: "C",
  names: "Callie, Camila, Caroline, Catherine, Charlotte, Chloe, Clara, Cora, Cecilia, Charlie, Claire"
}, {
  letter: "D",
  names: "Daisy, Dakota, Daniela, Daphne, Delilah, Destiny, Diana, Dorothy, Delaney, Dakota, Dylan"
}, {
  letter: "E",
  names: "Eden, Edith, Eleanor, Elena, Eliza, Elizabeth, Ella, Emma, Evelyn, Emilia, Everly, Eva"
}, {
  letter: "F",
  names: "Faith, Fatima, Felicity, Fiona, Flora, Florence, Frances, Francesca, Freya, Finley"
}, {
  letter: "G",
  names: "Gabriella, Genevieve, Georgia, Gianna, Grace, Gracie, Greta, Gwen, Gwendolyn, Gemma"
}, {
  letter: "H",
  names: "Hadley, Hailey, Haley, Hannah, Harper, Hazel, Heidi, Helen, Helena, Hope, Hazel"
}];
const trendingNames = [{
  id: 1,
  name: "Olivia",
  trend: "up"
}, {
  id: 2,
  name: "Emma",
  trend: "stable"
}, {
  id: 3,
  name: "Charlotte",
  trend: "up"
}, {
  id: 4,
  name: "Amelia",
  trend: "up"
}, {
  id: 5,
  name: "Ava",
  trend: "down"
}, {
  id: 6,
  name: "Sophia",
  trend: "stable"
}, {
  id: 7,
  name: "Isabella",
  trend: "down"
}];
export default function GirlNameDirectory() {
  return <section id="girl-name-directory" className="bg-background py-16 px-4 md:px-8 font-sans">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-4 gap-8">
        
        {}
        <div className="lg:col-span-3 space-y-10">
          
          {}
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold text-chart-1 tracking-tight">
              Girl Names Directory
            </h1>
            <p className="text-lg text-foreground max-w-2xl">
              A curated alphabetical list of beautiful and trending girl names. Browse through our comprehensive collection to find the perfect name.
            </p>
          </div>

          {}
          <div className="flex flex-wrap gap-2 p-4 bg-muted/30 border border-border">
            {alphabet.map((letter, i) => <Link key={letter} data-index={i} to={`#letter-${letter}`} className="w-8 h-8 flex items-center justify-center bg-background text-foreground hover:bg-accent hover:text-accent-foreground transition-colors text-sm font-medium border border-border">
                {letter}
              </Link>)}
          </div>

          {}
          <div className="space-y-12">
            {nameGroups.map((group, i) => <div key={group.letter} data-index={i} id={`letter-${group.letter}`} className="scroll-mt-24">
                <h2 className="text-3xl font-bold text-chart-1 border-b-2 border-accent pb-3 mb-6">
                  {group.letter}
                </h2>
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-y-4 gap-x-6">
                  {group.names.split(", ").map((name, j) => <div key={name} data-index={j} className="flex items-center">
                      <Link to="#" className="text-foreground hover:text-secondary transition-colors text-base font-medium w-full py-1">
                        {name}
                      </Link>
                    </div>)}
                </div>
              </div>)}
          </div>
          
          {}
          <div className="pt-8 flex justify-center border-t border-border">
             <Button variant="outline" className="text-chart-1 border-chart-1 hover:bg-chart-1 hover:text-primary-foreground rounded-none px-8 py-6 text-lg">
                Load More Names
             </Button>
          </div>

        </div>

        {}
        <div className="lg:col-span-1">
          <div className="sticky top-24 space-y-8">
            <Card className="bg-card border-none shadow-sm rounded-none">
              <CardHeader className="pb-4 border-b border-card-foreground/10">
                <CardTitle className="text-xl font-bold text-chart-1">
                  Trending Girls Names
                </CardTitle>
              </CardHeader>
              <CardContent className="pt-6">
                <ul className="space-y-4">
                  {trendingNames.map((item, i) => <li key={item.id} data-index={i} className="flex items-center justify-between group">
                      <Link to="#" className="text-card-foreground group-hover:text-secondary font-medium transition-colors text-base">
                        {i + 1}. {item.name}
                      </Link>
                      <span className="text-card-foreground/60 flex items-center justify-center w-6 h-6">
                        {item.trend === "up" && <TrendingUp className="w-4 h-4 text-chart-2" />}
                        {item.trend === "down" && <TrendingDown className="w-4 h-4 text-destructive" />}
                        {item.trend === "stable" && <Minus className="w-4 h-4" />}
                      </span>
                    </li>)}
                </ul>
                <Button variant="default" className="w-full mt-8 bg-secondary text-secondary-foreground hover:bg-accent hover:text-accent-foreground rounded-none py-6 text-base font-semibold transition-colors">
                  View Top 100
                </Button>
              </CardContent>
            </Card>
            
            {}
            <Card className="bg-muted border-none shadow-sm rounded-none">
              <CardContent className="p-6 text-center space-y-4">
                 <h3 className="text-lg font-bold text-chart-1">Need Inspiration?</h3>
                 <p className="text-sm text-foreground">Try our random name generator to find unique ideas.</p>
                 <Button variant="outline" className="w-full rounded-none border-chart-1 text-chart-1 hover:bg-chart-1 hover:text-primary-foreground">
                    Generate Name
                 </Button>
              </CardContent>
            </Card>
          </div>
        </div>

      </div>
    </section>;
}